import env from './env';

export const isProd = env?.ENV === 'PROD';
export const isStaging = env?.ENV === 'STAGING';
export const isDev = env?.ENV === 'DEV';
